/**
 * A v4 UUID for the correlation header (API-013).
 *
 * `crypto.randomUUID` exists only in a SECURE CONTEXT. `localhost` counts as one; a plain
 * `http://` LAN address does not. Calling it there throws, and because it is called while
 * building the headers of every request, the throw happened before anything was sent —
 * every API call failed, including the login, and the application was a blank page with an
 * empty console. `crypto.getRandomValues` carries no such restriction.
 */
export function correlationId(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // RFC 4122 §4.4: version 4 in the high nibble of byte 6, variant 10x in byte 8.
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0'));

  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
}
